import React from 'react';
import { motion,  } from 'framer-motion';
import '../styles/colors.css';

const CardIcon = ({ title, description, icon }) => {

  return (
    <>
      <motion.div
        
        className="p-6 card-icon flex flex-col items-center cursor-pointer block overflow-hidden"
        whileHover={{ scale: 1.05 }}
      >
        <img src={icon} alt={title} className=" w-full h-[120px] mb-4 object-contain " />
        <h4 className="text-xl font-bold">{title}</h4>
        <p className="mt-4">{description}</p>
      </motion.div>
    
    </>
  );
};

export default CardIcon;
